<script setup lang="ts">
import { useForwardPropsEmits } from "radix-vue";
import type { DialogRootEmits, DialogRootProps } from "radix-vue";
import { ResponsiveDialogContent } from "@/components/ui/responsive-dialog";

const props = defineProps<DialogRootProps & { title?: string }>();
const emits = defineEmits<DialogRootEmits>();

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
    <Dialog v-bind="forwarded">
        <ResponsiveDialogContent class="overflow-hidden p-0 shadow-lg">
            <Command
                class="[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-textForeground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5">
                <slot />
            </Command>
        </ResponsiveDialogContent>
        <DialogTitle v-if="props.title" class="hidden">{{ props.title }}</DialogTitle>
    </Dialog>
</template>
